import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { BookMarked } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { GlossaryPage } from "./pages/GlossaryPage";

export const glossaryModule: FeatureModule = {
  key: "glossary",
  nav: {
    label: "Glossary",
    icon: BookMarked,
    to: "/glossary",
    requires: "glossary.read",
    // Sits just under Design System in the Tools group.
    order: 121,
    group: "Tools",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/glossary",
      component: guarded("glossary.read", GlossaryPage),
    }),
  ] as unknown as AnyRoute[],
};
